/*
 * Pialu — Yape Checkout Widget
 * Auto-injected modal that lets customers pay via Yape (Mercado Pago QR)
 * bypassing the Shopify checkout. Uploaded to the theme as assets/yape-checkout.js.
 *
 * Design tokens mirror the live site (see charte-graphique.md):
 *   - font: "DM Sans" (body) / Helvetica (titles)
 *   - primary: #121212 / white, uppercase, letter-spacing 0.04em, radius 0
 *   - accent: #E91E8C (Pialu pink), used only as sparse accent
 *   - Yape brand: #662D91 (logo only, never as full bg of primary CTA)
 */
(function () {
  'use strict';

  if (window.YapeCheckout) return;

  var DEFAULT_CFG = {
    proxyBase: 'https://pialu-yape-api.vercel.app',
    currencySymbol: 'S/.',
    shopMoneyFormat: '{{amount}}',
    pollIntervalMs: 2500,
    qrExpiryMs: 9 * 60 * 1000,
    logoUrl: null,
  };
  var CFG = window.YAPE_CHECKOUT_CONFIG = Object.assign({}, DEFAULT_CFG, window.YAPE_CHECKOUT_CONFIG || {});

  var STYLES = [
    '.yape-btn{display:inline-flex;align-items:center;justify-content:center;gap:10px;width:100%;padding:16px 24px;background:#fff;color:#121212;border:1px solid #121212;border-radius:0;font-family:"DM Sans",sans-serif;font-weight:700;font-size:14px;text-transform:uppercase;letter-spacing:0.04em;cursor:pointer;transition:background .18s ease,color .18s ease}',
    '.yape-btn:hover{background:#f7f7f7}',
    '.yape-btn:disabled{opacity:.5;cursor:not-allowed}',
    '.yape-btn svg{flex:0 0 auto;height:20px;width:auto}',
    '.yape-btn .yape-btn-label{font:inherit;line-height:1}',
    '.yape-btn--cart{margin-top:10px}',
    '.yape-modal-backdrop{position:fixed;inset:0;background:rgba(0,0,0,.8);z-index:2147483647;display:none;align-items:center;justify-content:center;font-family:"DM Sans",sans-serif}',
    '.yape-modal-backdrop.open{display:flex}',
    '.yape-modal{background:#fff;width:100%;max-width:480px;max-height:100vh;overflow-y:auto;position:relative;animation:yapeFadeIn .18s ease}',
    '@keyframes yapeFadeIn{from{opacity:0;transform:translateY(8px)}to{opacity:1;transform:none}}',
    '@media (max-width:640px){.yape-modal{max-width:100%;height:100vh;max-height:100vh}}',
    '.yape-modal__header{display:flex;align-items:center;justify-content:space-between;padding:20px 24px;border-bottom:1px solid rgba(18,18,18,.1)}',
    '.yape-modal__title{font-family:Helvetica,Arial,sans-serif;font-weight:700;font-size:16px;text-transform:uppercase;letter-spacing:0.04em;color:#121212;margin:0}',
    '.yape-modal__close{background:none;border:none;cursor:pointer;padding:4px;display:flex;color:#121212}',
    '.yape-modal__body{padding:24px}',
    '.yape-step__intro{font-size:14px;color:#646464;margin:0 0 20px;line-height:1.5}',
    '.yape-field{display:block;margin-bottom:16px}',
    '.yape-field label{display:block;font-size:12px;font-weight:700;text-transform:uppercase;letter-spacing:0.04em;color:#121212;margin-bottom:6px}',
    '.yape-field input,.yape-field select,.yape-field textarea{width:100%;padding:12px;border:1px solid rgba(18,18,18,.4);border-radius:0;font-family:"DM Sans",sans-serif;font-size:15px;color:#121212;background:#fff;box-sizing:border-box}',
    '.yape-field input:focus,.yape-field select:focus{outline:none;border-color:#121212}',
    '.yape-row{display:grid;grid-template-columns:1fr 1fr;gap:12px}',
    '.yape-actions{display:flex;gap:12px;margin-top:24px}',
    '.yape-btn-primary{flex:1;padding:16px 24px;background:#121212;color:#fff;border:none;border-radius:0;font-family:"DM Sans",sans-serif;font-weight:700;font-size:13px;text-transform:uppercase;letter-spacing:0.04em;cursor:pointer;transition:background .18s}',
    '.yape-btn-primary:hover{background:#242424}',
    '.yape-btn-primary:disabled{opacity:.5;cursor:not-allowed}',
    '.yape-btn-secondary{padding:16px 24px;background:#fff;color:#121212;border:1px solid #121212;border-radius:0;font-family:"DM Sans",sans-serif;font-weight:700;font-size:13px;text-transform:uppercase;letter-spacing:0.04em;cursor:pointer}',
    '.yape-rates{margin:8px 0 16px}',
    '.yape-rate{display:flex;align-items:center;gap:10px;padding:12px;border:1px solid rgba(18,18,18,.2);margin-bottom:8px;cursor:pointer;background:#fff}',
    '.yape-rate.selected{border-color:#121212;background:#f7f7f7}',
    '.yape-rate input{margin:0}',
    '.yape-rate__title{flex:1;font-size:14px;color:#121212}',
    '.yape-rate__price{font-weight:700;color:#121212}',
    '.yape-summary{background:#f7f7f7;padding:16px;margin-bottom:20px}',
    '.yape-summary__row{display:flex;justify-content:space-between;font-size:14px;padding:4px 0;color:#646464}',
    '.yape-summary__row--total{font-weight:700;color:#121212;font-size:16px;border-top:1px solid rgba(18,18,18,.2);padding-top:10px;margin-top:8px}',
    '.yape-qr{display:flex;flex-direction:column;align-items:center;padding:20px 0}',
    '.yape-qr__canvas{padding:20px;border:1px solid rgba(100,100,100,.3);background:#fff}',
    '.yape-qr__timer{margin-top:16px;font-size:13px;color:#646464;font-variant-numeric:tabular-nums}',
    '.yape-qr__instructions{margin-top:16px;font-size:13px;color:#646464;text-align:center;line-height:1.5}',
    '.yape-qr__logo{display:flex;align-items:center;gap:8px;margin-bottom:16px;font-weight:700;color:#121212;text-transform:uppercase;letter-spacing:0.04em;font-size:13px}',
    '.yape-success{text-align:center;padding:32px 16px}',
    '.yape-success__icon{width:56px;height:56px;border-radius:50%;background:#0EA352;color:#fff;display:flex;align-items:center;justify-content:center;margin:0 auto 16px;font-size:28px}',
    '.yape-success__title{font-family:Helvetica,Arial,sans-serif;font-weight:700;font-size:18px;text-transform:uppercase;letter-spacing:0.04em;color:#121212;margin:0 0 8px}',
    '.yape-success__meta{font-size:14px;color:#646464}',
    '.yape-error{padding:12px 16px;background:rgba(208,47,46,.08);color:#D02F2E;font-size:13px;margin-bottom:16px}',
    '.yape-spinner{display:inline-block;width:14px;height:14px;border:2px solid rgba(18,18,18,.2);border-top-color:#121212;border-radius:50%;animation:yapeSpin .7s linear infinite;vertical-align:-2px;margin-right:6px}',
    '@keyframes yapeSpin{to{transform:rotate(360deg)}}',
  ].join('');

  var YAPE_LOGO = (CFG.logoUrl)
    ? '<img src="' + CFG.logoUrl + '" alt="Yape" style="width:26px;height:26px;flex:0 0 auto;object-fit:contain;display:inline-block;vertical-align:middle;">'
    : '<svg viewBox="0 0 24 24" aria-hidden="true" style="width:26px;height:26px;"><rect width="24" height="24" rx="4" fill="#662D91"/><path d="M7 7l5 6 5-6v4l-5 6-5-6V7z" fill="#fff"/></svg>';

  function injectStyles() {
    if (document.getElementById('yape-checkout-styles')) return;
    var style = document.createElement('style');
    style.id = 'yape-checkout-styles';
    style.textContent = STYLES;
    document.head.appendChild(style);
  }

  function fmt(amount) { return CFG.currencySymbol + ' ' + Number(amount).toFixed(2); }

  function el(tag, attrs, children) {
    var e = document.createElement(tag);
    if (attrs) Object.keys(attrs).forEach(function (k) {
      if (k === 'class') e.className = attrs[k];
      else if (k === 'html') e.innerHTML = attrs[k];
      else if (k.indexOf('on') === 0 && typeof attrs[k] === 'function') e.addEventListener(k.slice(2), attrs[k]);
      else e.setAttribute(k, attrs[k]);
    });
    (children || []).forEach(function (c) { if (c) e.appendChild(typeof c === 'string' ? document.createTextNode(c) : c); });
    return e;
  }

  function loadQRCodeLib() {
    if (window.QRCode) return Promise.resolve();
    return new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = 'https://cdn.jsdelivr.net/npm/qrcode@1.5.3/build/qrcode.min.js';
      s.onload = resolve;
      s.onerror = function () { reject(new Error('qrcode lib failed to load')); };
      document.head.appendChild(s);
    });
  }

  function api(path, opts) {
    return fetch(CFG.proxyBase + path, Object.assign({
      headers: { 'Content-Type': 'application/json' },
    }, opts || {})).then(function (r) {
      return r.json().then(function (body) {
        if (!r.ok) throw new Error(body.error || ('HTTP ' + r.status));
        return body;
      });
    });
  }

  function getShopifyCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }

  function Modal() {
    var root = el('div', { class: 'yape-modal-backdrop', 'aria-hidden': 'true' });
    var modal = el('div', { class: 'yape-modal', role: 'dialog', 'aria-modal': 'true' });
    var header = el('div', { class: 'yape-modal__header' });
    var title = el('h2', { class: 'yape-modal__title' }, ['Pagar con Yape']);
    var closeBtn = el('button', { class: 'yape-modal__close', 'aria-label': 'Cerrar' });
    closeBtn.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 6L6 18M6 6l12 12"/></svg>';
    header.appendChild(title); header.appendChild(closeBtn);
    var body = el('div', { class: 'yape-modal__body' });
    modal.appendChild(header); modal.appendChild(body);
    root.appendChild(modal);
    document.body.appendChild(root);
    closeBtn.addEventListener('click', close);
    root.addEventListener('click', function (e) { if (e.target === root) close(); });
    function open() { root.classList.add('open'); root.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
    function close() { root.classList.remove('open'); root.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }
    function setBody(node) { body.innerHTML = ''; body.appendChild(node); }
    return { open: open, close: close, setBody: setBody, title: title };
  }

  function renderError(msg) { return el('div', { class: 'yape-error' }, [msg]); }

  function renderAddressStep(state, onSubmit) {
    var wrap = el('div');
    wrap.appendChild(el('p', { class: 'yape-step__intro' }, ['Completa tus datos para generar el QR de pago con Yape.']));
    var form = el('form', { novalidate: '' });
    var fields = [
      ['email', 'Email', 'email', state.customer.email, true],
      ['name', 'Nombres y apellidos', 'text', state.customer.name, true],
      ['phone', 'Celular', 'tel', state.customer.phone, true],
      ['dni', 'DNI', 'text', state.dni, true],
      ['address1', 'Direccion', 'text', state.address.address1, true],
      ['city', 'Ciudad', 'text', state.address.city, true],
      ['province', 'Departamento', 'text', state.address.province || 'Lima', true],
    ];
    var inputs = {};
    fields.forEach(function (f) {
      var field = el('div', { class: 'yape-field' });
      field.appendChild(el('label', { for: 'yape-' + f[0] }, [f[1] + (f[4] ? ' *' : '')]));
      var input = el('input', { id: 'yape-' + f[0], type: f[2], value: f[3] || '' });
      if (f[4]) input.required = true;
      field.appendChild(input);
      form.appendChild(field);
      inputs[f[0]] = input;
    });
    var errBox = el('div');
    form.appendChild(errBox);
    var submit = el('button', { class: 'yape-btn-primary', type: 'submit' }, ['Continuar']);
    var actions = el('div', { class: 'yape-actions' }, [submit]);
    form.appendChild(actions);
    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      errBox.innerHTML = '';
      var data = {
        customer: { email: inputs.email.value.trim(), name: inputs.name.value.trim(), phone: inputs.phone.value.trim() },
        dni: inputs.dni.value.trim(),
        address: { address1: inputs.address1.value.trim(), city: inputs.city.value.trim(), province: inputs.province.value.trim() },
      };
      if (!data.customer.email || !data.customer.name || !data.customer.phone || !data.dni || !data.address.address1 || !data.address.city) {
        errBox.appendChild(renderError('Por favor completa todos los campos obligatorios.'));
        return;
      }
      submit.disabled = true; submit.innerHTML = '<span class="yape-spinner"></span>Calculando envio...';
      onSubmit(data).catch(function (e) {
        submit.disabled = false; submit.textContent = 'Continuar';
        errBox.appendChild(renderError(e.message || 'Error calculando el envio.'));
      });
    });
    wrap.appendChild(form);
    return wrap;
  }

  function renderRatesStep(state, rates, onConfirm, onBack) {
    var wrap = el('div');
    wrap.appendChild(el('p', { class: 'yape-step__intro' }, ['Elige tu metodo de envio.']));
    var ratesList = el('div', { class: 'yape-rates' });
    var selected = rates[0];
    rates.forEach(function (r, i) {
      var row = el('div', { class: 'yape-rate' + (i === 0 ? ' selected' : '') });
      var rb = el('input', { type: 'radio', name: 'yape-rate', value: String(i) });
      if (i === 0) rb.checked = true;
      row.appendChild(rb);
      row.appendChild(el('span', { class: 'yape-rate__title' }, [r.title]));
      row.appendChild(el('span', { class: 'yape-rate__price' }, [fmt(r.price)]));
      row.addEventListener('click', function () {
        ratesList.querySelectorAll('.yape-rate').forEach(function (n) { n.classList.remove('selected'); });
        row.classList.add('selected');
        rb.checked = true;
        selected = rates[i];
      });
      ratesList.appendChild(row);
    });
    wrap.appendChild(ratesList);
    var errBox = el('div');
    wrap.appendChild(errBox);
    var back = el('button', { class: 'yape-btn-secondary', type: 'button', onclick: onBack }, ['Atras']);
    var confirm = el('button', { class: 'yape-btn-primary', type: 'button' }, ['Generar QR Yape']);
    confirm.addEventListener('click', function () {
      errBox.innerHTML = '';
      confirm.disabled = true; confirm.innerHTML = '<span class="yape-spinner"></span>Generando QR...';
      onConfirm(selected).catch(function (e) {
        confirm.disabled = false; confirm.textContent = 'Generar QR Yape';
        errBox.appendChild(renderError(e.message || 'Error generando el QR.'));
      });
    });
    wrap.appendChild(el('div', { class: 'yape-actions' }, [back, confirm]));
    return wrap;
  }

  function isMobile() {
    return /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent || '');
  }

  function renderQRStep(state, qrData, initPoint, onExpired) {
    var wrap = el('div', { class: 'yape-qr' });
    var summary = el('div', { class: 'yape-summary' });
    summary.appendChild(el('div', { class: 'yape-summary__row' }, ['Subtotal', fmt(state.total - state.shipping.price)]));
    summary.appendChild(el('div', { class: 'yape-summary__row' }, ['Envio: ' + state.shipping.title, fmt(state.shipping.price)]));
    summary.appendChild(el('div', { class: 'yape-summary__row yape-summary__row--total' }, ['Total', fmt(state.total)]));
    wrap.appendChild(summary);

    if (isMobile() && initPoint) {
      // --- Mobile flow : deep link to Yape app via MP init_point ---
      wrap.appendChild(el('div', { class: 'yape-qr__logo', html: YAPE_LOGO + '<span>Pagar con Yape desde tu celular</span>' }));
      var btn = el('a', {
        href: initPoint,
        target: '_blank',
        rel: 'noopener',
        style: 'display:flex;align-items:center;justify-content:center;gap:10px;width:100%;height:57px;padding:14px 24px;margin:20px 0 10px;background:#662D91;color:#fff;border:0;border-radius:8px;font-family:Poppins,"DM Sans",sans-serif;font-weight:600;font-size:15px;text-decoration:none;cursor:pointer;',
      }, ['Abrir Yape']);
      wrap.appendChild(btn);
      wrap.appendChild(el('p', { class: 'yape-qr__instructions' }, [
        'Al tocar "Abrir Yape", se abrira la app para confirmar el pago de ' + fmt(state.total) + '. Vuelve a esta pantalla despues del pago.',
      ]));
    } else {
      // --- Desktop flow : QR scanable avec un autre telephone ---
      wrap.appendChild(el('div', { class: 'yape-qr__logo', html: YAPE_LOGO + '<span>Escanea con tu app Yape</span>' }));
      var qrContainer = el('div', { class: 'yape-qr__canvas' });
      if (qrData && typeof qrData === 'object' && qrData.image) {
        qrContainer.appendChild(el('img', { src: qrData.image, alt: 'QR Yape', style: 'display:block;width:240px;height:240px;' }));
      } else if (typeof qrData === 'string' && qrData.length) {
        var canvas = el('canvas');
        qrContainer.appendChild(canvas);
        loadQRCodeLib().then(function () {
          window.QRCode.toCanvas(canvas, qrData, { width: 240, margin: 1, color: { dark: '#121212', light: '#ffffff' } });
        });
      } else {
        qrContainer.appendChild(el('div', { class: 'yape-error' }, ['QR no disponible. Intenta de nuevo.']));
      }
      wrap.appendChild(qrContainer);
      wrap.appendChild(el('div', { class: 'yape-qr__instructions' }, [
        '1. Abre Yape en tu celular.  2. Escanea este codigo QR.  3. Confirma el pago.',
      ]));
    }

    var timer = el('div', { class: 'yape-qr__timer' }, ['Expira en 09:00']);
    wrap.appendChild(timer);
    var expiresAt = Date.now() + CFG.qrExpiryMs;
    var interval = setInterval(function () {
      var remaining = Math.max(0, Math.floor((expiresAt - Date.now()) / 1000));
      var m = Math.floor(remaining / 60); var s = remaining % 60;
      timer.textContent = 'Expira en ' + String(m).padStart(2, '0') + ':' + String(s).padStart(2, '0');
      if (remaining <= 0) { clearInterval(interval); onExpired(); }
    }, 1000);
    wrap._cleanup = function () { clearInterval(interval); };
    return wrap;
  }

  function renderSuccess(state) {
    var wrap = el('div', { class: 'yape-success' });
    wrap.appendChild(el('div', { class: 'yape-success__icon' }, ['✓']));
    wrap.appendChild(el('h3', { class: 'yape-success__title' }, ['Pago confirmado']));
    wrap.appendChild(el('p', { class: 'yape-success__meta' }, ['Recibiras un email de confirmacion en ' + state.customer.email + '.']));
    return wrap;
  }

  function startFlow(lineItems) {
    injectStyles();
    var modal = Modal();
    modal.open();
    var state = {
      lineItems: lineItems,
      customer: { email: '', name: '', phone: '' },
      dni: '',
      address: { address1: '', city: '', province: 'Lima' },
      shipping: null,
      total: 0,
      draftOrderId: null,
      qrData: null,
      initPoint: null,
    };

    function goAddress() {
      modal.title.textContent = 'Tus datos';
      modal.setBody(renderAddressStep(state, function (data) {
        Object.assign(state.customer, data.customer);
        state.dni = data.dni;
        Object.assign(state.address, data.address);
        return api('/api/yape/shipping-rates', {
          method: 'POST',
          body: JSON.stringify({ line_items: state.lineItems, address: state.address }),
        }).then(function (res) {
          if (!res.rates || !res.rates.length) throw new Error('No hay opciones de envio para tu direccion.');
          goRates(res.rates);
        });
      }));
    }
    function goRates(rates) {
      modal.title.textContent = 'Envio';
      modal.setBody(renderRatesStep(state, rates, function (rate) {
        state.shipping = rate;
        return api('/api/yape/create-qr', {
          method: 'POST',
          body: JSON.stringify({
            line_items: state.lineItems,
            customer: state.customer,
            address: state.address,
            shipping_rate: rate,
            dni: state.dni,
          }),
        }).then(function (res) {
          state.draftOrderId = res.draft_order_id;
          state.total = res.total_amount;
          state.qrData = res.qr_data;
          state.initPoint = res.init_point;
          goQR();
          startPolling();
        });
      }, goAddress));
    }
    function goQR() {
      modal.title.textContent = isMobile() ? 'Pagar con Yape' : 'Escanea con Yape';
      var node = renderQRStep(state, state.qrData, state.initPoint, function () {
        modal.setBody(renderError('El codigo QR ha expirado. Por favor intenta nuevamente.'));
      });
      modal.setBody(node);
    }
    function goSuccess() {
      modal.title.textContent = 'Listo';
      modal.setBody(renderSuccess(state));
    }
    var polling = null;
    function startPolling() {
      polling = setInterval(function () {
        if (!state.draftOrderId) return;
        api('/api/yape/status?draft_order_id=' + state.draftOrderId).then(function (res) {
          if (res.state === 'paid') { clearInterval(polling); goSuccess(); }
        }).catch(function () {});
      }, CFG.pollIntervalMs);
    }
    goAddress();
  }

  var YapeCheckout = {
    config: CFG,
    openFromPDP: function (variantId, qty) {
      startFlow([{ variant_id: Number(variantId), quantity: Number(qty) || 1 }]);
    },
    openFromCart: function () {
      getShopifyCart().then(function (cart) {
        if (!cart.items || !cart.items.length) { alert('Tu carrito esta vacio.'); return; }
        var items = cart.items.map(function (it) { return { variant_id: it.variant_id, quantity: it.quantity }; });
        startFlow(items);
      });
    },
  };

  window.YapeCheckout = YapeCheckout;

  function buildYapeBtn(variant) {
    var logoHtml = CFG.logoUrl
      ? '<img src="' + CFG.logoUrl + '" alt="Yape" style="width:26px;height:26px;flex:0 0 auto;object-fit:contain;">'
      : '<svg viewBox="0 0 24 24" aria-hidden="true" style="width:22px;height:22px;"><rect width="24" height="24" rx="4" fill="#662D91"/><path d="M7 7l5 6 5-6v4l-5 6-5-6V7z" fill="#fff"/></svg>';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.setAttribute('data-yape-cart', '');
    btn.setAttribute('data-yape-cart-injected', '');
    btn.setAttribute('aria-label', 'Pagar con Yape');
    btn.className = 'pialu-yape-btn pialu-yape-btn--' + (variant || 'cart');
    btn.innerHTML = logoHtml + '<span>Pagar con Yape</span>';
    btn.addEventListener('click', function () { YapeCheckout.openFromCart(); });
    return btn;
  }

  // Inject into UpCart drawer (React 3rd-party app that replaces native Shopify drawer)
  // DISABLED 2026-06-06 (Aurèle): the Yape button is no longer shown in the UpCart
  // drawer (nor on the PDP). Kept the function so the rest of the widget — the /cart
  // page button and the payment modal flow — keeps working.
  function injectUpCart() {
    return;
    /* eslint-disable no-unreachable */
    var popup = document.getElementById('CartPopup');
    if (!popup) return;
    var footer = popup.querySelector('.upcart-footer');
    if (!footer) return;
    if (footer.querySelector('[data-yape-cart-injected]')) return;
    var continueShop = footer.querySelector('.upcart-continue-shopping');
    var checkoutBox = footer.querySelector('.upcart-checkout-button-container');
    var yape = buildYapeBtn('upcart');
    if (continueShop) continueShop.parentElement.insertBefore(yape, continueShop);
    else if (checkoutBox) checkoutBox.insertAdjacentElement('afterend', yape);
    else footer.appendChild(yape);
  }

  // Inject into the /cart page (native Shopify), but ONLY if the Liquid render didn't already put one
  function injectCartPage() {
    if (location.pathname.indexOf('/cart') !== 0) return;
    document.querySelectorAll('.cart__input-buttons').forEach(function (wrap) {
      var parent = wrap.parentElement;
      if (!parent) return;
      if (parent.querySelector('[data-yape-cart]')) return;
      parent.insertBefore(buildYapeBtn('cart'), wrap.nextSibling);
    });
  }

  function runInjection() {
    console.log('[Yape] widget booting', location.pathname);
    injectUpCart();
    injectCartPage();
    var obs = new MutationObserver(function () {
      injectUpCart();
      injectCartPage();
    });
    obs.observe(document.body, { childList: true, subtree: true });
    console.log('[Yape] widget ready, upcart=' + !!document.querySelector('#CartPopup [data-yape-cart-injected]') + ', cart-page=' + document.querySelectorAll('.cart__footer-inner [data-yape-cart]').length);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runInjection);
  } else {
    runInjection();
  }

  document.addEventListener('click', function (e) {
    var pdp = e.target.closest('[data-yape-pdp]');
    if (pdp) {
      e.preventDefault();
      var form = pdp.closest('form[action*="/cart/add"]');
      var variantId = pdp.getAttribute('data-variant-id') || (form && form.querySelector('[name="id"]') && form.querySelector('[name="id"]').value);
      var qtyInput = form && form.querySelector('[name="quantity"]');
      var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
      YapeCheckout.openFromPDP(variantId, qty);
      return;
    }
    var cartBtn = e.target.closest('[data-yape-cart]');
    if (cartBtn) {
      e.preventDefault();
      YapeCheckout.openFromCart();
    }
  });
})();
